import axios from "axios";
import { API_ROUTE, encodePathValue, headersRequest } from "../../../helpers";

export const ResourcesAsigServices = {
  getDataForTable: async (data) => {
    try {
      const safeResourceId = encodePathValue(data.id_resource);
      const safeYear = encodePathValue(data.year_date);
      const safeMonth = encodePathValue(data.month_date);
      const result = await axios.get(
        `${API_ROUTE}available-resource/${safeResourceId}?Year=${safeYear}&Month=${safeMonth}`,
        headersRequest(),
      );

      if (result.status == 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
  getDataClusterByFilter: async (data) => {
    try {
      const result = await axios.get(
        `${API_ROUTE}delivery-dashboard-users-cluster-ocupation?Cluster=${data.IdCluster}&Rol=${data.Idrol}&Position=${data.position}&Name=${data.IdUser}&StartDate=${data.start_date}&EndDate=${data.end_date}`,
        headersRequest(),
      );
      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
};
